import React from 'react'
import './input-round.scss'

const InputRound = ({
  register,
  errors,
  messageError,
  resetError,
  type = 'text',
  placeholder = '',
  hidden = false,
  edgeStatus = false,
  label,
  setPasswordStatus,
  className = '',
  ...props
}) => {
  return (
    <div className={`f-input-round ${className}`} hidden={hidden}>
      {label && (
        <label className="f-input-round__label" htmlFor="input">
          {label}
        </label>
      )}

      <input
        className="f-input-round__field"
        onFocus={messageError && resetError}
        type={type}
        placeholder={placeholder}
        {...props}
        {...register}
      />
      {(type === 'password' || edgeStatus) && (
        <div className="f-input-round__edge">
          {/* <IconButton
            edge="end"
            aria-label="toggle password visibility"
            onClick={() => {
              setPasswordStatus(!edgeStatus)
            }}
            onMouseDown={e => e.preventDefault()}
            onMouseDown={e => e.preventDefault()}
          >
            {edgeStatus ? (
              <Icons.VisibilityOff className="f-btn-password" />
            ) : (
              <Icons.Visibility className="f-btn-password" />
            )}
          </IconButton> */}
        </div>
      )}

      {register && (errors[register?.name] || messageError) && (
        <span className="f-input-round__error">
          {errors[register?.name].message || messageError}
        </span>
      )}
    </div>
  )
}

export default InputRound
